import Rollbar, { Configuration } from "rollbar/src/browser/core"
import scrub from "rollbar/src/scrub"
import { useEffect } from "react"
import { WebAppConfig } from "./web-app-config"
import { isBrowser } from "./rendering"

// TODO: ass the rollbar config directly 'rollbarConfig(config)'
//  and put the necessary dependencies explicitly (accessToken, code_version, environment, NODE_ENV)
export function useSetupRollbar(config: WebAppConfig) {
    useEffect(() => setupRollbar(config), [])
}

export function setupRollbar(config: WebAppConfig) {
    if (!isBrowser()) return

    Rollbar.setComponents({
        //telemeter: telemeter,
        //instrumenter: instrumenter,
        //polyfillJSON: polyfillJSON,
        //wrapGlobals: wrapGlobals,
        scrub: scrub,
        //truncation: truncation
    })
    window.Rollbar = Rollbar
    window.rollbar = new Rollbar(rollbarConfig(config))
}

export const rollbarConfig = (config: WebAppConfig): Configuration => {
    const {
        NODE_ENV,
        rollbar: { accessToken, code_version, environment },
    } = config

    return {
        enabled: NODE_ENV === "production",
        accessToken: accessToken || undefined,
        captureUncaught: false,
        captureUnhandledRejections: false,
        captureIp: "anonymize" as const,
        environment,
        payload: {
            environment,
            client: {
                javascript: {
                    source_map_enabled: true,
                    code_version: code_version || undefined,
                    guess_uncaught_frames: true,
                },
            },
        },
        ignoredMessages: ["file:///C:/"],
    }
}
